<!--
 * @Description: 监控列表
-->
<template>
  <div class="w-full h-full flex flex-col">
    <div class="w-full h-[calc(40%-5px)] mt-5px" v-if="relativeTableData.length">
      <CategoryTitle title="关联监控" class="self-center" />
      <el-table
        :data="relativeTableData"
        height="calc(100% - 30px)"
        style="width: 100%"
        class="mb-10px"
        @row-click="locationMonitor"
        v-loading="tableLoading"
      >
        <el-table-column prop="name" label="摄像头名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="50">
          <template #default="{ row }">
            <div @click.stop="viewDetail(row)" class="cursor-pointer">查看</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="h-[calc(60%)]" :class="{ '!h-full':!relativeTableData.length }">
      <CategoryTitle title="附近监控" class="self-center" />
      <el-table
        :data="tableData"
        height="calc(100% - 20px)"
        style="width: 100%"
        @row-click="locationMonitor"
        v-loading="tableLoading"
      >
        <!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
        <el-table-column prop="name" label="附近摄像头名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="distance"
          label="距离"
          width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="50">
          <template #default="{ row }">
            <div @click.stop="viewDetail(row)" class="cursor-pointer">查看</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        small
        background
        @size-change="getTableData()"
        @current-change="getTableData()"
        :current-page.sync="initPagination.pageNum"
        :page-size.sync="initPagination.pageSize"
        :pager-count="5"
        layout="prev, pager, next"
        :total="initPagination.total"
        class="text-center"
      ></el-pagination> -->

    </div>
    <videoDialog
      v-if="videoDialogShow"
      :show.sync="videoDialogShow"
      :code="cameraCode"
      :pIid="pIid"
      :showControlPanel="true"
      :manufacturerCode="manufacturerCode"
      :daHuaParams="daHuaParams"
    ></videoDialog>
  </div>
</template>

<script>
import { toInteger } from 'lodash'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { Tag3DPositionApi, Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import { Tag3DCameraPositionsApi, IOTDeviceApi } from '@wiz-api/iot-device-management'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import videoDialog from '../components/video/videoDialog'


const dataCategoryApi = new DataCategoryApi()
const tag3DPositionManagementAPI = new Tag3DPositionApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()
const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
const iotDeviceApi = new IOTDeviceApi()
export default {
  name: 'cockpit-cameralist',
  components: {
    videoDialog,
    CategoryTitle,
  },
  props: {
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    cloudRender: {
      type: Object,
      defalut: null,
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    customProps: {
      type: Object,
      defalut: () => {},
    },
  },
  data() {
    return {
      initPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      manufacturerCode: '', // 厂商
      pIid: '', // 宇视才需要这个pIid
      cameraCode: '',
      videoDialogShow: false,
      deviceTypeList: [],
      basicIconList: [], // 基础图标集合,用于找出该摄像头设置的图标名称
      iconTypeList: [],
      basicImgType: '',
      deviceType: '',
      cameraMarkerList: [], // 三维里需要显示的摄像头集合
      cameraMarkerIds: [],
      textMarkerIds: [],
      relativeTableData: [], // 关联摄像头列表
      daHuaParams: {}, // 大华参数
    }
  },
  computed: {
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-tongre-vulkan']?.config
    },
    // 图标的最大可见距离
    maxLod() {
      return this.modelSetting?.cameraDistanceConfig?.maxLod || null
    },
    // 图标的最大可见距离
    minLod() {
      return this.modelSetting?.cameraDistanceConfig?.minLod || null
    },
    nearbyNumber() {
      return this.modelSetting?.cameraListConfig?.nearbyNumber || 10
    },
    isShowMakerText() {
      return this.modelSetting?.cameraListConfig?.isShowMakerText
    },
  },
  watch: {
    cameraMarkerList(val) {
      this.delMarkers()
      this.delTextMarkers()
      this.createCameraMarker()
      if (!this.isShowMakerText) return
      if (Array.isArray(val) && val.length > 0) {
        val.forEach((item) => {
          this.createTextMakers(item)
        })
      }
    },
  },
  async mounted() {
    await this.getCameraList()
    await this.getDeviceType()
    await this.getCategoryByCodes()
    await this.getBasicIconList()
    // 左键点击标记事件
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
    // 鼠标移入显示文本标记
    this.player && this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
  },
  methods: {
    async getCameraList() {
      if (this.transferProps.code) {
        const [err, res] = await iotDeviceApi.getDeviceWithDetailPageList({
          deviceTypeCode: this.transferProps.code,
          maxResultCount: 1000,
        })
        if (res && !err) {
          this.relativeTableData = res.items
        }
      }
    },
    // 定位监控
    locationMonitor(row) {
      if (row.tag3DPositionDto?.threeDAngleView) {
        const cameraParams = JSON.parse(row.tag3DPositionDto.threeDAngleView)
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
    // 获取设备类型
    async getDeviceType() {
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagTypeList()
      if (!err) {
        const deviceTypeList = res || []
        this.deviceTypeList = deviceTypeList
        const queryName = 'IOTDeviceCamera'
        const findItem = deviceTypeList.find((n) => {
          return n.code.includes(queryName)
        })
        this.deviceType = (findItem && findItem.code) || queryName
      }
    },
    // 监控列表
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
        x: this.transferProps.pos[0],
        y: this.transferProps.pos[1],
        _number: this.nearbyNumber,
      })
      if (!err) {
        this.tableData = (res || []).map((item) => {
          return {
            ...item,
            distance: toInteger(item.distance)
          }
        })
        this.initPagination.total = res.totalCount
        if (this.player && this.player.Native) {
          this.cameraMarkerList = []
          this.handleCameraData()
        }
      }
      this.tableLoading = false
    },
    // 数据字典获取图标类型
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['Tag3DPositionImgType'],
        includeDetails: true,
      })
      if (!err) {
        this.iconTypeList = res[0] && res[0].dataItems
        const findBasicItem = _.find(this.iconTypeList, (item) => {
          return item.code.toLowerCase() === 'base'
        })
        this.basicImgType = findBasicItem && findBasicItem.id
      }
    },
    // 获取基础图标列表
    async getBasicIconList() {
      if (this.basicImgType && this.deviceType) {
        const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
          imgType: this.basicImgType, // 必传
          tagTypeCode: this.deviceType, // 必传
          skipCount: 0,
          maxResultCount: 1000,
        })
        if (!err) {
          this.basicIconList = res && res.items
          this.getTableData()
        }
      }
    },
    async viewDetail(row) {
      this.pIid = row.pIid
      this.cameraCode = row.code || ''
      this.manufacturerCode = row.manufacturerCode || 'UniView'
      this.daHuaParams = {
        id: row.id,
        code: row.code,
      }
      this.videoDialogShow = true
      const str = sessionStorage.getItem('cameraMarkList')
      if (str && JSON.parse(str).length) {
        const markList = JSON.parse(str)
        const index = _.findIndex(markList, ['id', row.tag3DPositionRelationKey])
        if (index > -1) {
          const treeData = await this.player.Native.ModelTree.getRootItems()
          this.player?.Native.Camera.moveToPos(
            JSON.parse(markList[index].threeDPosition),
            treeData[0]?.nodePtr,
            50,
            2
          )
        }
      }
    },
    // 处理监控列表数据显示在三维里
    handleCameraData() {
      const cameras = this.tableData.filter((item) => {
        return item.tag3DPositionDto
      })
      // 摄像头标记信息
      const cameraMarkerList = cameras.map((camera) => {
        return {
          name: camera.name,
          pos:
            (camera.tag3DPositionDto.threeDPosition &&
              JSON.parse(camera.tag3DPositionDto.threeDPosition)) ||
            [],
          code: camera.code,
          cameraId: camera.tag3DPositionRelationKey,
          tagFileImgId: camera.tag3DPositionDto.tagFileImgId,
          manufacturerCode: camera.manufacturerCode,
          pIid: camera.pIid,
          id: camera.id
        }
      })
      this.cameraMarkerList = cameraMarkerList
    },
    // 创建摄像头标记
    createCameraMarker() {
      this.cameraMarkerList.forEach(async (camera) => {
        const basicIconInfo = this.basicIconList.find((item) => {
          return item.id === camera.tagFileImgId
        })
        const iconName = basicIconInfo && basicIconInfo.originalFileName
        this.player.Native.GisMarker.loadImage(
          // `data://apps/gat/img/${iconName || 'icon-camara-blue.png'}`,
          `data://../apps/markers/${iconName || 'camera.png'}`,
          (id) => {
            const option = {
              name: camera.name,
              pos: camera.pos, // 定位点，世界坐标，三维向量
              nodeOffset: [0, 0],
              imgId: id, // 图片id
              imgSize: [32, 46],
              visible: true,
            }
            // if (this.maxLod) option.maxLod = this.maxLod
            // if (this.minLod) option.minLod = this.minLod
            this.player.Native.GisMarker.create(option, (markerId) => {
              this.cameraMarkerIds.push({
                markerId,
                name: camera.name,
                type: 'camera',
                code: camera.code,
                cameraId: camera.cameraId,
                manufacturerCode: camera.manufacturerCode,
                pIid: camera.pIid,
                id: camera.id
              })
            })
          }
        )
      })
    },
    // 删除图标标记
    delMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.cameraMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.cameraMarkerIds = []
    },
    // 删除名称标记
    delTextMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.textMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.textMarkerIds = []
    },
    // 创建文本标记
    createTextMakers(item) {
      if (!item) return
      this.player.Native.GisMarker.loadImage(item.imgBackgroundColor || 'rgba:0,0,0,135', (id) => {
        const nameLength = item.name?.length
        const textRows = Math.ceil((nameLength * 15) / 150)
        const imgHeight = textRows * 15 + 10
        const option = {
          pos: item.pos, // 定位点，世界坐标，三维向量
          nodeOffset: [32, -(32 + 15 * (textRows - 1))], // 相对定位点的偏移量，二维向量
          imgId: id, // 图片id
          imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30],
          text: item.name || '', // 文本
          textFontSize: 15.0, // 字体大小
          breakWidth: 150, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          textColor: 0xffffffff, // 文本颜色
          title: null, // 标题
          contentPadding: [5, 5, 5, 5],
        }
        // if (this.maxLod) option.maxLod = this.maxLod
        // if (this.minLod) option.minLod = this.minLod
        this.player.Native.GisMarker.create(option, (markerId) => {
          this.textMarkerIds.push({
            markerId,
          })
        })
      })
    },
    // 标记点击
    markerClick(info) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === info.markerId
      })
      if (markerInfo && markerInfo.type === 'camera' && markerInfo.code) {
        this.cameraCode = markerInfo.code || ''
        this.manufacturerCode = markerInfo.manufacturerCode || 'UniView'
        this.pIid = markerInfo.pIid || ''
        this.daHuaParams = {
          id: markerInfo.id,
          code: markerInfo.code,
        }
        this.videoDialogShow = true
      }
    },
    // 标记鼠标移入
    markerHover(e) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === e.markerId
      })
      if (markerInfo) {
        const val = this.cameraMarkerList.find((item) => {
          return item.cameraId === markerInfo.cameraId
        })
        this.createTextMakers(val)
      } else {
        // 移出删除文本标记
        this.delTextMarkers()
      }
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
  },
  beforeDestroy() {
    this.delMarkers()
    this.delTextMarkers()
    this.backInitPositon()
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
    this.player && this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
  },
}
</script>

<style lang="scss" scoped>
.button-wrap {
  background: url('../../../assets/images/button_blue.png');
  background-size: 100% 100%;
}
</style>
